import { Filters } from '../../../model/Filters'

const all = ['questionnaire_templates']
const lists = [...all, 'list']
const list = (filters?: Filters) => [...lists, filters]
const detail = (id: number) => [...all, id]

export const questionnaireTemplatesKeys = {
  all,
  lists,
  list,
  detail,
}
